import React from 'react'

import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useTranslationRankmi } from 'helpers/translations.helper'

export type NormativeStartAccessVariant =
  | 'missingAttestation'
  | 'incompleteProfile'

interface NormativeStartAccessModalProps {
  isOpen: boolean
  variant: NormativeStartAccessVariant | null
  onClose: () => void
}

export const NormativeStartAccessModal: React.FC<NormativeStartAccessModalProps> =
  ({ isOpen, variant, onClose }) => {
    const t = useTranslationRankmi({
      prefix: 'lessons.modals.normativeStartAccess',
    })
    const tButtons = useTranslationRankmi({
      prefix: 'lessons.modals.buttons',
    })

    if (!variant) {
      return null
    }

    const handleDismiss = () => {
      onClose()
    }

    return (
      <Modal
        isOpen={isOpen}
        title={t(`${variant}.title`)}
        isConfirmation
        maxwidth={520}
        maxheight={320}
        close={handleDismiss}
        actions={
          <ModalButtons
            secondaryText={tButtons('accept')}
            secondaryAction={handleDismiss}
            secondaryIsPrimary
          />
        }
      >
        {String(t(`${variant}.body`))}
      </Modal>
    )
  }

export default NormativeStartAccessModal
